const React = require('react');
const delay = require('mn-utils/delay');
const param = require('mn-utils/param');
const noop = require('mn-utils/noop');
const formatTime = require('mn-utils/formatTime');
const withState = require('../../../utils/withState');
const WrapperWithLoading = require('../WrapperWithLoading/B');
const ButtonDownload = require('../Button/DownloadA');
const ButtonPrint = require('../Button/PrintA');
const Tooltip = require('../Tooltip/A');


module.exports = withState((setState) => {
  return (state, props) => {
    const {
      urlPrefix,
      disablePrint
    } = props;
    const prefix = props.prefix || 'transactions';
    const filter = props.filter || {};
    const {
      from: dateFrom = 0,
      to: dateTo,
      search,
      min_amount,
      max_amount,
      ...rest
    } = filter;

    const formatTime = (date) => Math.floor(new Date(date).getTime() * 0.001);

    function getLink(key) {
      const params = {
        // from: dateFrom ? Math.floor(dateFrom * 0.001) : null,
        // to: dateTo ? Math.floor(dateTo * 0.001) : null,
        from: dateFrom ? formatTime(dateFrom) : null,
        to: dateTo ? formatTime(dateTo) : null,
        search: search || null,
        ...rest
      }

      // console.log(min_amount, max_amount);

      const rangeHasError = min_amount && max_amount ? Number(min_amount) > Number(max_amount) : false;
      const addEurFlag = (min_amount || max_amount) && !rangeHasError;

      if (min_amount && !rangeHasError) params['min_amount'] = min_amount;
      if (max_amount && !rangeHasError) params['max_amount'] = max_amount;
      if (addEurFlag) params['use_eur_amount'] = true;

      // console.log(params);

      const queryString = param(params);
      return urlPrefix + key + (queryString ? ('?' + queryString) : '');
    }
    function getName(key) {
      return prefix + '_'
        + formatTime(dateFrom, '{yyyy}-{mm}-{dd}') + '_'
        + (dateTo ? formatTime(dateTo, '{yyyy}-{mm}-{dd}') : '')
        + '.' + key;
    }
    function handleLoading() {
      setState({
        loading: true,
      });
      delay(setState, 2000, [{loading: false}]);
    }

    const threeMonthsAhead = new Date(dateFrom);
    const monthPlusThree = threeMonthsAhead.getMonth() + 3;

    if (monthPlusThree > 12) {
      threeMonthsAhead.setMonth(monthPlusThree - 12);
      threeMonthsAhead.setFullYear(threeMonthsAhead.getFullYear() + 1);
    } else {
      threeMonthsAhead.setMonth(monthPlusThree);
    }

    const disableButtons = new Date(dateTo) > new Date(threeMonthsAhead);

    const Wrapper = ({children}) => disableButtons
      ? (
        <Tooltip title="Interval should be less than 3 month" disabledCopy>
          {children}
        </Tooltip>
      ) : (
        <>{children}</>
      )

    return (
      <WrapperWithLoading
        loading={state.loading}
        inner={{
          className: 'layoutRow fvaC fhaS hmin34*2 ' + (props.className || ''),
        }}
      >
        {!disablePrint && (
          <Wrapper>
            <ButtonPrint
              className={"(cA3A7AC|crD).disabled" + (disableButtons ? ' disabled' : '')}
              onClick={disableButtons ? noop : handleLoading}
              target="_blank"
              href={disableButtons ? undefined : getLink('pdf')}
              download={getName('pdf')}
            />
          </Wrapper>
        )}
        <Wrapper>
          <ButtonDownload
            className={"ml36 (cA3A7AC|crD).disabled" + (disableButtons ? ' disabled' : '')}
            onClick={disableButtons ? noop : handleLoading}
            target="_blank"
            href={disableButtons ? undefined : getLink('csv')}
            download={getName('csv')}
            name="Download CSV"
          />
        </Wrapper>
      </WrapperWithLoading>
    );
  };
});
